import { render, staticRenderFns } from "./Paylist.vue?vue&type=template&id=b0964054"
import script from "./Paylist.vue?vue&type=script&lang=js"
export * from "./Paylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports